import React, { useState, useRef, useEffect } from "react";
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";

const ExpandableSection = ({ title, content, defaultOpen = false, variant = "default" }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const contentRef = useRef(null);
  const [height, setHeight] = useState(defaultOpen ? "auto" : "0px");

  useEffect(() => {
    if (isOpen) {
      const scrollHeight = contentRef.current?.scrollHeight;
      setHeight(scrollHeight + "px");

      const timeout = setTimeout(() => {
        setHeight("auto");
      }, 300);
      return () => clearTimeout(timeout);
    } else {
      const scrollHeight = contentRef.current?.scrollHeight;
      setHeight(scrollHeight + "px");
      requestAnimationFrame(() => {
        setHeight("0px");
      });
    }
  }, [isOpen]);

  const isMinimal = variant === "minimal";

  return (
    <div
      className={`
        expandable-section 
        w-full
        ${isMinimal ? "" : "border border-[#0000001A] rounded-[4px] mt-[24px]"}
      `}
    >
      <div
        className="title-arrow flex justify-between items-center cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <p className={`
          ${isMinimal ? "ml-0 mt-4 mb-4" : "ml-[20px] mt-[20px] mb-[18.5px]"} 
          font-semibold text-[18px] leading-[100%] text-neutral-black
          max-md:text-[16px]
        `}>
          {title}
        </p>
        <span className={`${isMinimal ? "mr-0 mt-0" : "mr-[20px] mt-[16px]"}`}>
          {isOpen ? (
            <IoIosArrowUp className="h-[32px] w-[32px] max-md:h-[24px] max-md:w-[24px]" />
          ) : (
            <IoIosArrowDown className="h-[32px] w-[32px] max-md:h-[24px] max-md:w-[24px]" />
          )}
        </span>
      </div>

      <div
        ref={contentRef}
        style={{
          maxHeight: height,
          overflow: "hidden",
          transition: "max-height 0.3s ease",
        }}
      >
        <div className={`
          ${isMinimal ? "mt-2 mx-0 mb-4" : "mt-[16px] mx-[20px] mb-[20px]"} 
          text-[16px] text-neutral-700 leading-[140%] max-md:text-[14px]
        `}>
          {typeof content === "string" ? (
            <p>{content?.replace(/<[^>]+>/g, "")}</p>
          ) : (
            content
          )}
        </div>
      </div>
    </div>
  );
};

export default ExpandableSection;
